var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('user-service-create',{attrs:{"user-service-update":_vm.userService,"title":_vm.$t('user_service.page.update'),"button-text":_vm.$t('user_service.buttons.update')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }